export const isMobile = () => document.location.href.indexOf("?m=1") !== -1;
